import { Package, ShoppingBag, Coffee, Shirt, Weight, Users, Truck, Target, Shield, Leaf, Award } from 'lucide-react';

const mockData = {
  heroSlides: [
    {
      title: 'Para Restaurantes e Hamburguerias',
      subtitle: 'Soluções que valorizam sua entrega, protegem o alimento e encantam o cliente',
      description: 'Seja para delivery ou consumo no local, nossas embalagens são feitas para resistir à gordura, preservar a temperatura e valorizar cada detalhe do seu produto.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/u6un4bn0_2.png'
    },
    {
      title: 'Para Lojas de Roupas, Souvenirs e Presentes',
      subtitle: 'Estética, proteção e valorização da marca em cada embalagem',
      description: 'Embalagens personalizadas que ampliam a percepção de valor dos seus produtos. Cores, formatos e acabamentos pensados para oferecer uma experiência encantadora desde o momento da entrega.',
      image: 'https://images.unsplash.com/photo-1760565030401-c37ce3432ad6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxzaG9wcGluZyUyMGJhZ3MlMjBib3V0aXF1ZXxlbnwwfHx8fDE3NjA5ODMyOTZ8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      title: 'Sacos Costurados e Embalagens para Produtos Pesados',
      subtitle: 'Resistência técnica para quem precisa de confiança no transporte',
      description: 'Desenvolvemos sacos costurados e embalagens robustas sob medida para segmentos como carvão, ração, grãos e produtos industriais. Capacidade de carga, reforço técnico e excelente custo-benefício.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/v170v7h1_1.png'
    }
  ],

  products: [
    {
      icon: <Package className="w-20 h-20" />,
      title: 'Delivery e Restaurantes',
      description: 'Soluções práticas, resistentes e visualmente atrativas. Protegem o alimento e elevam a percepção da sua marca. Com opções específicas para frituras e entregas de longa distância.'
    },
    {
      icon: <Package className="w-20 h-20" />,
      title: 'Comida Japonesa e Gastronomia Oriental',
      description: 'Embalagens que garantem segurança, frescor e estética impecável para pratos delicados.'
    },
    {
      icon: <Coffee className="w-20 h-20" />,
      title: 'Padarias e Lanchonetes',
      description: 'Sacos e sacolas personalizados para pães, doces e salgados. Práticos, higiênicos e com ótima apresentação no balcão.'
    },
    {
      icon: <Shirt className="w-20 h-20" />,
      title: 'Vestuário, Presentes e Souvenirs',
      description: 'Sacolas com acabamento premium para reforçar a identidade da sua loja e gerar valor percebido.'
    },
    {
      icon: <Weight className="w-20 h-20" />,
      title: 'Sacos Costurados e Produtos Pesados',
      description: 'Ideais para carvão, lenha, rações e outros produtos de maior volume e peso. Alta resistência, personalização e acabamento profissional.'
    },
    {
      icon: <ShoppingBag className="w-20 h-20" />,
      title: 'Soluções Personalizadas',
      description: 'Não encontrou o que procura? Desenvolvemos embalagens customizadas para qualquer segmento e necessidade específica.'
    }
  ],

  differentials: [
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Consultoria Personalizada',
      description: 'Ajudamos você a escolher a melhor embalagem para seu produto, dentro do seu orçamento e da sua necessidade real.'
    },
    {
      icon: <Truck className="w-8 h-8" />,
      title: 'Entrega Rápida e Eficiente',
      description: 'Atendimento ágil em Curitiba e região. Fretes para todo o Brasil com logística otimizada.'
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: 'Soluções Inteligentes e Econômicas',
      description: 'Opções padronizadas e modelos prontos para envio, que reduzem custos sem abrir mão da qualidade.'
    },
    {
      icon: <Package className="w-8 h-8" />,
      title: 'Ampla Variedade de Segmentos',
      description: 'Atuamos com restaurantes, hamburguerias, padarias, lojas de roupas, souvenirs, carvão e muito mais.'
    },
    {
      icon: <Shield className="w-8 h-8" />,
      title: 'Embalagens com Proteção Garantida',
      description: 'Modelos resistentes a frituras, líquidos e calor. Ideal para delivery e transporte sem vazamentos.'
    },
    {
      icon: <Leaf className="w-8 h-8" />,
      title: 'Produção Responsável',
      description: 'Compromisso com processos conscientes e materiais selecionados, respeitando o meio ambiente.'
    }
  ],

  portfolio: [
    {
      client: 'Casa do Sushi',
      segment: 'Restaurante Japonês',
      description: 'Embalagens com design clean e moderno que entrega a identidade de quem entende de sushi e qualidade.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/0uhcvnss_casa%20do%20sushi.png'
    },
    {
      client: 'Empório Kaminsky',
      segment: 'Empório e Padaria',
      description: 'Sacos elegantes e com alta resistência para pães, salgados e doces.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/a9m7ha7z_emporio%20kaminski.png'
    },
    {
      client: 'Veritá',
      segment: 'Alimentação Saudável',
      description: 'Comida saudável de verdade combina com o clássico que nunca sai de moda e valoriza a experiência natural.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/vdxpjm8y_verit%C3%A1.png'
    },
    {
      client: 'Garfo de Madeira',
      segment: 'Restaurante',
      description: 'Leva muito sabor em cada preparo e merece uma embalagem que conecte e gere emoções que aquecem o coração.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/ifjgw6bu_garfo.png'
    },
    {
      client: 'Ilha da Magia',
      segment: 'Loja de Presentes',
      description: 'As lembranças de uma grande viagem são elevadas em uma sacola que transmite toda experiência do que ela carrega.',
      image: 'https://customer-assets.emergentagent.com/job_jz-embalagens/artifacts/i7paln8k_ilha%20da%20magia.png'
    }
  ],

  testimonials: [
    {
      name: 'Amanda Lima',
      segment: 'Hamburgueria Artesanal',
      testimonial: 'Com as embalagens da JZ, nosso delivery mudou de patamar. Os clientes elogiam e a experiência ficou muito mais profissional. Recomendo demais!'
    },
    {
      name: 'Carlos Mendes',
      segment: 'Distribuidora de Carvão',
      testimonial: 'Precisávamos de sacos resistentes e a JZ entregou exatamente o que prometeu. Qualidade excepcional e prazo cumprido. Parceria de confiança!'
    },
    {
      name: 'Juliana Santos',
      segment: 'Boutique de Roupas',
      testimonial: 'As sacolas personalizadas agregaram muito valor à experiência de compra na minha loja. Minhas clientes adoram e sempre comentam sobre o acabamento.'
    },
    {
      name: 'Roberto Silva',
      segment: 'Padaria',
      testimonial: 'Atendimento impecável e produtos de qualidade. A JZ entende as necessidades do cliente e entrega soluções inteligentes. Super satisfeito!'
    },
    {
      name: 'Mariana Costa',
      segment: 'Restaurante Japonês',
      testimonial: 'Nossas embalagens para delivery são perfeitas! Mantêm a temperatura, são lindas e ainda reforçam nossa identidade visual. Obrigada, JZ!'
    },
    {
      name: 'Pedro Oliveira',
      segment: 'Loja de Presentes',
      testimonial: 'A consultoria da equipe foi fundamental para escolhermos a embalagem ideal. Resultado? Vendas aumentaram e clientes mais satisfeitos!'
    }
  ]
};

export default mockData;